import permissions from './permission-list'

export default [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {
      pageTitle: 'Dashboard',
      resource: permissions.dashboardRegistry,
      action: 'read',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard-registry',
    name: 'dashboard-registry',
    component: () => import('@/views/dashboard/registry/index.vue'),
    meta: {
      pageTitle: 'Dashboard Registry',
      resource: permissions.dashboardRegistry,
      action: 'read',
      breadcrumb: [
        {
          text: 'Dashboard Registry',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/product',
    name: 'dashboard-product',
    component: () => import('@/views/dashboard/product/index.vue'),
    meta: {
      pageTitle: 'Dashboard Produk',
      resource: permissions.dashboardProduct,
      action: 'read',
      breadcrumb: [
        {
          text: 'Dashboard Produk',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/brand',
    name: 'dashboard-brand',
    component: () => import('@/views/dashboard/brand/index.vue'),
    meta: {
      pageTitle: 'Dashboard Brand',
      resource: permissions.dashboardBrand,
      action: 'read',
      breadcrumb: [
        {
          text: 'Dashboard Brand',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/recapt',
    name: 'dashboard-recapt',
    component: () => import('@/views/dashboard/recapt/index.vue'),
    meta: {
      pageTitle: 'Dashboard Laporan Bulanan',
      resource: permissions.dashboardMonthly,
      action: 'read',
      breadcrumb: [
        {
          text: 'Dashboard Laporan Bulanan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard/recapt/transactions',
    name: 'dashboard-recapt-transactions',
    component: () => import('@/views/dashboard/recapt/TransactionPreview.vue'),
    meta: {
      pageTitle: 'Daftar Transaksi',
      resource: permissions.dashboardMonthly,
      action: 'read',
      layout: 'full',
      breadcrumb: [
        {
          text: 'Dashboard Laporan Bulanan',
          to: '/dashboard/recapt',
        },
        {
          text: 'Daftar Transaksi',
          active: true,
        },
      ],
    },
  },
]
